export const ProfessionPath = ["name", "description", "status"]

export const ProfessionHeading = (t) => [
    { title: t("Name"), field: "name" },
    { title: t("Notes"), field: "description" },
    { title: t("Status"), field: "status", },
    { title: "", field: "icon" },
]

export const ProfessionType = [
    { type: ["text"], name: "name" },
    { type: ["text"], name: "description" },
    { type: ["status"], name: "status" },
    { type: ["more"], icon: "icon" },
]

export const StatusOptionList = [
    { label: 'Active', value: true },
    { label: 'Inactive', value: false },
]

export const filterOptionList = (t) => [
    { label: t('Active'), value: true },
    { label: t('Inactive'), value: false },
]